import { render, staticRenderFns } from "./VaultManage.vue?vue&type=template&id=e290b4a6&scoped=true&"
import script from "./VaultManage.vue?vue&type=script&lang=ts&"
export * from "./VaultManage.vue?vue&type=script&lang=ts&"
import style0 from "./VaultManage.vue?vue&type=style&index=0&id=e290b4a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e290b4a6",
  null
  
)

export default component.exports